import React from 'react';
export function Navbar() {
  return <nav className="sticky top-0 z-50 bg-white shadow-sm" data-id="element-128">
      <div className="max-w-6xl mx-auto px-4 flex items-center justify-between" style={{
      height: '90px',
      paddingTop: '8px',
      paddingBottom: '8px'
    }} data-id="element-129">
        <div className="flex items-center" data-id="element-130">
          <img src="https://cdn.magicpatterns.com/uploads/vy6YPCN3kE63ZKxWgSB7L5/ChatGPT_Image_24_may_2026,_10_51_37_p.m..png" alt="El Código del Bienestar" style={{
          width: '200px',
          height: 'auto',
          maxHeight: '100%',
          objectFit: 'contain'
        }} className="block border-0 outline-none" data-id="element-131" />
        </div>
        <a href="#pricing" className="bg-primary text-white px-6 py-2.5 rounded-full font-medium hover:bg-primary/90 transition-colors shadow-sm hover:shadow-md" data-id="element-132">
          Quiero dormir mejor &rarr;
        </a>
      </div>
    </nav>;
}